import dva from 'dva'
import router from './router'
import LoginModel from './models/login'
import ClientModel from './models/client'
import HotelModel from './models/hotel'
import ProviderModel from './models/provider'
import SellerModel from './models/seller'
import TourModel from './models/tour'
import UserModel from './models/user'
import CategoryModel from './models/category'
import PaymentTypeModel from './models/paymentType'
import ActivityModel from './models/activity'
import EmployeeModel from './models/employee'
import IncomeModel from './models/income'
import BoucherAdonModel from './models/boucherAdon'

// 1. Initialize
const app = dva()

// 2. Model
app.model(LoginModel)
app.model(ClientModel)
app.model(HotelModel)
app.model(ProviderModel)
app.model(SellerModel)
app.model(TourModel)
app.model(UserModel)

app.model(CategoryModel)
app.model(PaymentTypeModel)
app.model(ActivityModel)
app.model(EmployeeModel)

app.model(IncomeModel)
app.model(BoucherAdonModel)

// 3. Router
app.router(router);

// 4. Start
app.start('#root')


// WEBPACK FOOTER //
// ./src/index.js